/**
 * contains some methods that have been moved to this new domain according to latest
 * devtools developments
 */

import { highlightNode, hideHighlight } from './dom';

/**
 * Paints viewport size upon main frame resize.
 * @param {Boolean} show Whether to paint size or not.
 */
export function setShowViewportSizeOnResize({ show }) {
  // NYI
  return {};
}

export function setPausedInDebuggerMessage() {
  // NYI
  return {};
}

export { highlightNode, hideHighlight };
